import { apiUrls } from '@shared/helpers/api-urls';
import api from '@shared/store/api';
import { COMPANY_MEMBER } from '@shared/store/company/api-tags';
import { Id } from '@shared/types/global';
import { USER_ME } from './api-tags';
import { RegistrationRequest, RegistrationResponse } from './types/registration';
import { ICheckRegistrationQuery, ISetPassword, IUser, IUserCreateRequest, IUserMe, IUserMeUpdate, IUserTrialCreateRequest, UserUpdateRequest } from './types/user-schemas';

// TODO Убрать тэги, когда добавят отдельные эндпоинты на добавление и редактирование company_members
const userApi = api.enhanceEndpoints({ addTagTypes: [COMPANY_MEMBER, USER_ME] }).injectEndpoints({
    endpoints: (build) => ({
        registerCompany: build.mutation<RegistrationResponse, RegistrationRequest>({
            query: (body) => ({
                url: apiUrls.registration(),
                method: 'POST',
                body,
            }),
        }),
        createUser: build.mutation<IUser, IUserCreateRequest>({
            query: (body) => ({
                url: apiUrls.users(),
                method: 'POST',
                body,
            }),
            invalidatesTags: () => [{ type: COMPANY_MEMBER }],
        }),
        createUserTrial: build.mutation<IUser, IUserTrialCreateRequest>({
            query: (body) => ({
                url: apiUrls.trial(),
                method: 'POST',
                body,
            }),
            invalidatesTags: () => [{ type: COMPANY_MEMBER }],
        }),
        getUserMe: build.query<IUserMe, void>({
            query: () => ({
                url: apiUrls.usersMe(),
                method: 'GET',
            }),
            providesTags: [USER_ME],
        }),
        updateUserMe: build.mutation<IUserMe, IUserMeUpdate | FormData>({
            query: (body) => ({
                url: apiUrls.usersMe(),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [USER_ME],
        }),
        getUser: build.query<IUserMe, Id>({
            query: (id) => ({
                url: apiUrls.userInfo(id),
                method: 'GET',
            }),
        }),
        setPassword: build.mutation<ISetPassword, ISetPassword>({
            query: (body) => ({
                url: apiUrls.setPassword(),
                method: 'POST',
                body,
            }),
        }),
        updateUser: build.mutation<IUser, UserUpdateRequest>({
            query: ({ id, ...body }: { id: number }) => ({
                url: apiUrls.userInfo(id),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: () => [{ type: COMPANY_MEMBER }],
        }),
        getCheckRegistration: build.mutation<{ [index: string]: boolean }, ICheckRegistrationQuery>({
            query: (body) => ({
                url: apiUrls.checkRegistration(),
                method: 'GET',
                params: {
                    ...body,
                },
            }),
        }),
    }),
});

export const { useRegisterCompanyMutation, useCreateUserMutation, useCreateUserTrialMutation, useGetUserMeQuery, useGetUserQuery, useUpdateUserMeMutation, useSetPasswordMutation, useUpdateUserMutation, useGetCheckRegistrationMutation } = userApi;
